import * as React from "react";
import { Modal, Button } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { AppointmentAndParent } from "@teamprevent/common/calendar/models";
import { ClinicLocationTypeName, ClinicLocationTypes } from "@teamprevent/common/appointment/models";

import { BookAppointmentTaskListModel } from "../models";

interface Props {
    open: boolean;
    bookAppointmentTask: BookAppointmentTaskListModel;
    appointment: AppointmentAndParent;
    onCancel: () => void;
    onSubmit: (location: ClinicLocationTypeName) => void;
}

const LocationTypeSelectorModal: React.FunctionComponent<Props> = (props) => {
    const [location, setLocation] = React.useState<ClinicLocationTypeName>();
    const [submitted, setSubmitted] = React.useState(false);

    const onChangeLocation = (selectedLocation: ClinicLocationTypeName) => setLocation(selectedLocation);

    const onSubmit = () => {
        setSubmitted(true);
        if (!location) {
            return;
        }

        props.onSubmit(location);
    };

    return (
        <Modal open={!!props.open}>
            <Modal.Header>How will the appointment be conducted?</Modal.Header>
            <Modal.Content>
                <Input.Dropdown
                    value={location}
                    options={ClinicLocationTypes.map(t => ({ text: t, value: t }))}
                    onChange={onChangeLocation}
                    showErrors={submitted}
                    required
                />
            </Modal.Content>
            <Modal.Actions>
                <Button content="Cancel" onClick={props.onCancel} />
                <Button content="Submit" onClick={onSubmit} />
            </Modal.Actions>
        </Modal>
    );
};

export { LocationTypeSelectorModal };
